import { render, staticRenderFns } from "./bardd.vue?vue&type=template&id=daabe2b6&scoped=true"
import script from "./bardd.vue?vue&type=script&lang=js"
export * from "./bardd.vue?vue&type=script&lang=js"
import style0 from "./bardd.vue?vue&type=style&index=0&id=daabe2b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daabe2b6",
  null
  
)

export default component.exports